import React, { useCallback, useState } from 'react';
import { Table, Space, Tooltip } from 'antd';
import { 
  TableWrapper, 
  StudentEditModal, 
  StudentDeleteModal, 
  StudentExcelUploadModal,
  B2cMailSendModal, 
  B2cMultiMailSendModal,
  CompanyEditModal, 
  BillB2CRequestModal, 
  BillB2CPublicModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { TotalStudentMenu } from 'components/atoms';
import { ColumnsType } from 'antd/lib/table/interface';
import { fetcher } from 'services';
import { CarryOutOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx';

interface FormItemProps {
  info: LectureInfoDto;
  group: string;
  studentList: StudentListDto[];  
  refetch: () => void;
}

const StudentList = ({info, group, studentList, refetch}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const { open } = usePopupManager();
  const [selected, setSelectd] = useState<number[]>();
  const [selectedStudent, setSelectdStudent] = useState<string[]>();
  const [selectedCrm, setSelectdCrm] = useState<string[]>();

  const columns: ColumnsType<StudentListDto> = [
    {
      title: '번호',
      key: 'num',
      width: '50px',
      align: 'center',
      fixed: 'left',
      render: (text, record, index) => {
        return (
          index+1
        )
      }        
    },  
    {
      title: '결제수단',
      key: 'ebill_yn',
      dataIndex: 'ebill_yn',
      width: '100px',
      align: 'center',
      fixed: 'left',
      render: (ebill_yn, record) => {
        return (
          (!!record.bill_type)?record.bill_type:(ebill_yn==='Y')?'세금계산서 발행':(ebill_yn==='N')?'온라인 카드결제':'기타'
        )
      }        
    }, 
    {
      title: '발행일자',
      key: 'bill_date',
      dataIndex: 'bill_date',
      width: '100px',
      align: 'center',
      fixed: 'left',
      render: (bill_date, record) => {
        return (
          (record.bill_price===record.mem_price)?<a onClick={(e) => {
            e.stopPropagation();
          }}><label style={{color:'black'}}>{bill_date}</label></a>:<label style={{color:'red'}}>{record.ebill_etc}</label>
        )
      }        
    },      
    {
      title: '교육비 (vat 포함)',
      dataIndex: 'mem_price',
      key: 'mem_price',
      width: '150px',
      align: 'right',
      fixed: 'left',
      render: (mem_price, record) => {
        const price = mem_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+' ('+(mem_price*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+')';
        return (
          <a onClick={(e) => {
            e.stopPropagation();

            if (record.bill_price===record.mem_price) {
              open(BillB2CPublicModal, {
                id: record.bill_id,
                onClose: (isOk) => {
                  if (isOk) {}
                },
              }); 
            } else {
              open(BillB2CRequestModal, {
                id: record.group_id,
                student_id: record.id,
                onClose: (isOk) => {
                  if (isOk) {refetch()}
                },
              });  
            }
          }}>
            <label style={{color:(record.bill_price!==record.mem_price)?'red':'black'}}>{price}</label>
          </a>
        )
      }       
    },     
    {
      title: '회사명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '130px',
      align: 'center', 
      ellipsis: true,  
      fixed: 'left', 
      sorter: (a, b) => a.company_name.localeCompare(b.company_name),
      render: (company_name, record) => {
        return record.company_srl && record.edu_srl?
          <a onClick={(e) => {
            e.stopPropagation();
            open(CompanyEditModal, {
              id: record.company_srl,
              isPopup: true,
              onClose: (isOk) => {if(isOk) refetch();},
            }); 
          }}>
            <label style={{color:'black'}}>{company_name}</label>
          </a>:<label style={{color:'red'}}>{company_name}</label>        
      }          
    },  
    {
      title: '부서명',
      dataIndex: 'department',
      key: 'department',
      width: '120px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: '이름',
      dataIndex: 'name_kor',
      key: 'name_kor',
      width: '90px',
      align: 'center',
      fixed: 'left',
      ellipsis: true,  
      sorter: (a, b) => a.name_kor.localeCompare(b.name_kor),
      render: (name_kor, record) => {
        return (
          (record.memo)?(
            <Tooltip placement="topLeft" title={record.memo}>
              <CarryOutOutlined />&nbsp;{name_kor}
            </Tooltip>
            
          ):(name_kor)
        )
      }  
    },   
    {
      title: '휴대폰',
      dataIndex: 'phone',
      key: 'phone',
      width: '100px',
      align: 'center',
      ellipsis: true,  
      render: (phone) => {
        return (
          phone&&phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
        )
      } 
    },    
    {
     title: '이메일',
     dataIndex: 'email',
     key: 'email',
     width: '150px',
     align: 'center',
     ellipsis: true,     
   },
   {
    title: '영문명',
    dataIndex: 'name_eng',
    key: 'name_eng',
    width: '100px',
    align: 'center',
    ellipsis: true,   
    sorter: (a, b) => a.name_eng.localeCompare(b.name_eng),  
  },   
  {
    title: '메일발송현황',
    children: [
      {
        title: '교육담당자',
        dataIndex: 'mail_type06',
        key: 'mail_type06',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type06');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type06_status==='40'?'#d9363e':record.mail_type06_status==='20'?'#52c41a':record.mail_type06_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }         
      },  
      {
        title: '신청확인',
        dataIndex: 'mail_type07',
        key: 'mail_type07',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type07');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type07_status==='40'?'#d9363e':record.mail_type07_status==='20'?'#52c41a':record.mail_type07_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }           
      },  
      {
        title: '참석안내',
        dataIndex: 'mail_type09',
        key: 'mail_type09',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type09');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type09_status==='40'?'#d9363e':record.mail_type09_status==='20'?'#52c41a':record.mail_type09_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }          
      },    
      {
        title: '현황공유',
        dataIndex: 'mail_type12',
        key: 'mail_type12',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type12');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type12_status==='40'?'#d9363e':record.mail_type12_status==='20'?'#52c41a':record.mail_type12_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }           
      },    
      {
        title: '보고서전달',
        dataIndex: 'mail_type13',
        key: 'mail_type13',
        width: '80px',
        align: 'center',
        onCell: (record) => {
          return {
              onClick: (e) => {
                e.stopPropagation();
                onSendMail(record.id, 'type13');
              },
          };
        },
        render: (text, record) => {
          const color = record.mail_type13_status==='40'?'#d9363e':record.mail_type13_status==='20'?'#52c41a':record.mail_type13_status==='30'?'#faad14':'black';
          return (
            <label style={{color:color}}>{text}</label>
          )
        }          
      },                                        
    ]
  },   
  {
   title: '기능',
   key: 'act',
   width: '80px',
   align: 'center',
   ellipsis: true,  
   render: (record) => {
    return (
      <>
        <a onClick={(e) => {
          e.stopPropagation();
          if (record.bill_price > 0) {
            alert("계산서가 발행되어 취소 할 수 없습니다.");
          } else {
            onUserCancel(false, record.id);
          }
        }}>취소</a>&nbsp;|&nbsp;
        <a onClick={(e) => {
          e.stopPropagation();
          if (record.bill_price > 0) {
            alert("계산서가 발행되어 연기 할 수 없습니다.");
          } else {
            onUserCancel(true, record.id);
          }
        }}>연기</a>
      </>
    )
  }      
 },
 {
  title: '담당자명',
  dataIndex: 'edu_name',
  key: 'edu_name',
  width: '80px',
  align: 'center',
  ellipsis: true,    
  sorter: (a, b) => a.edu_name.localeCompare(b.edu_name),   
},    
{
  title: '담당자직급',
  dataIndex: 'edu_position',
  key: 'edu_position',
  width: '80px',
  align: 'center',
  ellipsis: true,  
  sorter: (a, b) => a.edu_position.localeCompare(b.edu_position),      
},    
{
  title: '담당자전화',
  dataIndex: 'edu_phone',
  key: 'edu_phone',
  width: '100px',
  align: 'center',
  ellipsis: true,     
  render: (phone) => {
    return (
      phone&&phone.toString().replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
    )
  } 
},    
{
  title: '담당자이메일',
  dataIndex: 'edu_email',
  key: 'edu_email',
  width: '150px',
  align: 'center',
  ellipsis: true,     
},    
{
  title: '신청일',
  key: 'reg_dttm',
  dataIndex: 'reg_dttm',
  width: '80px',
  align: 'center',
  ellipsis: true,
  sorter: (a, b) => a.reg_dttm.localeCompare(b.reg_dttm),
}, 
 {
  title: '히스토리',
  dataIndex: 'history',
  key: 'history',
  width: '80px',
  align: 'center',
  ellipsis: true,     
},     
  ];

  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: StudentListDto[]) => {
      setSelectd(selectedRows.map((item) => item.id));
      setSelectdStudent(selectedRows.map((item) => item.name_kor));
      setSelectdCrm(selectedRows.map((item) => item.edu_name));
    },
    /*
    getCheckboxProps: (record: StudentListDto) => ({
      disabled: record.bill_price > 0
    }),
    */
  };
  
  const onRowClick = (record) => {
    return {
      onClick: () => {
        open(StudentEditModal, { 
          id: record.id,
          group: group,
          lectureInfo: info,
          onClose: (isOk) => {
            if (isOk) {   
              refetch();
            };
          },          
        }); 
      },
    };
   };

   const onRegister = () => {
      if (info.close_yn==='Y' || (info.student_max > 0 && info.student_max <= studentList?.length)) {
        if (info.close_yn==='Y') {
          alert('과정이 마감되어 등록 할 수 없습니다.');
        } else {
          alert('설정된 최대 인원을 초과하여 등록 할 수 없습니다.');
        }
        return;
      }

      open(StudentEditModal, { 
        id: 0,
        group: group,
        lectureInfo: info,
        onClose: (isOk) => {
          if (isOk) {   
            refetch();
          };
        },          
      }); 
   }; 
   

   const onRegisterExcel = () => {
    if (info.close_yn==='Y' || (info.student_max > 0 && info.student_max <= studentList?.length)) {
      if (info.close_yn==='Y') {
        alert('과정이 마감되어 등록 할 수 없습니다.');
      } else {
        alert('설정된 최대 인원을 초과하여 등록 할 수 없습니다.');
      }
      return;
    }

    open(StudentExcelUploadModal, { 
      lectureInfo: info,
      onClose: (isOk) => {
        if (isOk) {   
          refetch();
        };
      },          
    }); 
 };    

   const onUserCancel = (putoff: boolean, id: number) => {          
      if (!!info) {
          open(StudentDeleteModal, {
              lectureInfo: info,
              id: id,
              group: group,
              putoff: putoff,
              onClose: (isOk) => {
                if (isOk) {
                  refetch();
                };
              },
          });  
      }
  }   

  const onSendMail = (id: number, mail_type: string) => {          
    if (!!info) {
        open(B2cMailSendModal, {
            id: id,
            group: group,
            mail_type: mail_type,
            onClose: (isOk) => {
              if (isOk) {
                refetch();
              };
            },
        });  
    }
  }   

  const onSendMultiMail = (mail_type: string) => {          
    if (!!selected && selected.length > 0) {
        open(B2cMultiMailSendModal, {
            ids: selected.join(','),
            group: group,
            toStudents: selectedStudent?.join(',')+'',
            toCrms: selectedCrm?.join(',')+'', 
            mail_type: mail_type,
            onClose: (isOk) => {
              if (isOk) {
                refetch();
              };
            },
        });  
    } else {
      alert("대상을 선택해 주세요.");
    }
  }     

  const onDelete = () => {
    if (!!selected) {
      selected.forEach((id) => {
        fetcher.b2c.postStudentDelete({id: parseInt(id.toString())})
        .then((res) => {
            switch (res.code) {
                case 200:
                  refetch();
                break;
                default:  
                break;
            };
        });
      });
    }
  }

  const onDownloadExcel = () => {
    const book = XLSX.utils.book_new();
    
    const nurses = XLSX.utils.json_to_sheet(
      studentList.map((item, index) => {
        return {
          '번호' : index+1,
          '구분' : info.lecture_price>item.mem_price?'할인':'일반',
          '교육비': item.mem_price,
          '교육비(VAT포함)': item.mem_price*1.1,
          '결제방식': item.bill_type?item.bill_type:item.ebill_yn==='Y'?'세금계산서':item.ebill_yn==='N'?'온라인카드결제':'기타',
          '발행일자': item.bill_price===item.mem_price?item.bill_date:item.ebill_etc,
          '기업명': item.company_name,
          '부서': item.department,
          '이름': item.name_kor,
          '직위': item.position,
          '직책': item.duty,
          '연령': item.age,
          '성별': item.sex,
          '휴대폰': item.phone,
          '이메일': item.email,
          '영문이름': item.name_eng,
          '교육담당자': item.mail_type06,
          '신청확인': item.mail_type07,
          '참석안내': item.mail_type09,
          '현황공유': item.mail_type12,
          '보고서전달': item.mail_type13,
          '교육담당자이름': item.edu_name,
          '직급': item.edu_position,
          '연락처': item.edu_phone,
          '교육담당자이메일': item.edu_email,
          '계산서담당자이름': item.acc_name,
          '계산서담당자연락처': item.acc_phone,
          '계산서담당자이메일': item.acc_email,
          '지원경로': item.route,
          '메모': item.memo,
          '교육이력': item.memo2,
        }
      }), 
      { 
        header : [
          '번호',
          '구분',
          '교육비',
          '교육비(VAT포함)',
          '결제방식',
          '발행일자',
          '기업명',
          '부서',
          '이름',
          '직위',
          '직책',
          '연령',
          '성별',
          '휴대폰',
          '이메일',
          '영문이름',
          '교육담당자',
          '신청확인',
          '참석안내',
          '현황공유',
          '보고서전달',
          '교육담당자이름',
          '직급',
          '연락처',
          '교육담당자이메일',
          '계산서담당자이름',
          '계산서담당자연락처',
          '계산서담당자이메일',
          '지원경로',
          '메모',
          '교육이력',
        ], 
        skipHeader : false 
      } 
    );

    nurses["!cols"] = [
      { wpx : 60 } 
    , { wpx : 80 } 
    , { wpx : 100 }  
    , { wpx : 100 }  
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 200 } 
    , { wpx : 200 } 
    ]

    XLSX.utils.book_append_sheet( book, nurses, "NURSES" );

    XLSX.writeFile( book, info.lecture_title+".xlsx" ); 
  }
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
        <TotalStudentMenu 
          info={info}
          totalNum={studentList?.length} 
          onRegister={onRegister}
          onRegisterExcel={onRegisterExcel}
          onDelete={onDelete}
          onSendCertificate={() => onSendMultiMail("type13")}          
          onSendMail={() => onSendMultiMail("")} 
          onDownloadExcel={onDownloadExcel}
        />
        <TableWrapper isSearch={false}>
          <Table
            tableLayout="fixed"
            scroll={{ x: 1450 }}
            dataSource={studentList}
            columns={columns}
            pagination={false}
            onRow={onRowClick}
            style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
            className="columnCenterFixTable clickable"
            showSorterTooltip={false}
            rowKey={'id'}
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}            
          />
        </TableWrapper> 
    </Space>
  );
};

export default StudentList;
